export const GET_PARTNERS = 'GET_PARTNERS'
export const GET_PARTNER = 'GET_PARTNER'
export const GET_PARTNER_DISCOUNT_CODES = 'GET_PARTNER_DISCOUNT_CODES'

export const GET_PARTNER_USERS = 'GET_PARTNER_USERS'
export const GET_PARTNER_USER = 'GET_PARTNER_USER'
export const GET_PARTNER_USER_ASSESSMENTS = 'GET_PARTNER_USER_ASSESSMENTS'
export const GET_PARTNER_USER_DISCOUNT_CODES = 'GET_PARTNER_USER_DISCOUNT_CODES'
export const GET_PARTNER_USER_COMPANIES = 'GET_PARTNER_USER_COMPANIES'